import { api } from "./api"
import URI from "./URI"

export const getTechExcelProfile = () => {
    return api(
        URI.techExcelProfile,
        { tokenRequired:true },
        import.meta.env.VITE_PSVC_API_BASE
    ).then(response => {
        const data = response?.data

        // let address = ""
        // if(data?.residentialAddressLineOne){
        //     address += data.residentialAddressLineOne
        // }

        // if(data?.residentialAddressLineTwo){
        //     address += ", " + data.residentialAddressLineTwo
        // }

        // if(data?.residentialAddressLineThree){
        //     address += ", " + data.residentialAddressLineThree
        // }

        let accounts =  data?.banks.map(bank => (
            {
                bankAccountNumber: bank.Bank_AcNo,
                bankBranch: bank.Bank_Branch,
                bankAddress: bank.Bank_Address,
                bankName: bank.Bank_Name,
                bankIFSCNumber: bank.IFSC_Code,
                defaultAccount: bank.Default_Ac,
                isPrimary: false,
            }
        ))

        const nomineeDetails = [
            {
                nomineeName: data.Nominee_Name,
                nomineeRelation: data.Nominee_Relation,
                nomineeDob: data.Nominee_DOB,
                nomineeAlocation: data.Nominee_SharePercentage,
            },
            {
                nomineeName: data.Nominee2_Name,
                nomineeRelation: data.Nominee2_Relation,
                nomineeDob: data?.Nominee2_DOB,
                nomineeAlocation: data.Nominee2_SharePercentage,
            },
            {
                nomineeName: data.Nominee3_Name,
                nomineeRelation: data.Nominee3_Relation,
                nomineeDob: data.Nominee3_DOB,
                nomineeAlocation: data.Nominee3_SharePercentage,
            },
        ].filter((nominee) => nominee.nomineeName != "");

        const primaryAccount = accounts.find(account => account?.defaultAccount === "Yes");
        if (primaryAccount) {
            primaryAccount.isPrimary = true;
        }


        accounts = accounts.sort((a, b) => (b.isPrimary === true) - (a.isPrimary === true));

        return {
            accounts,
            nomineeDetails
        }
    }).catch(error => {
        throw error
    })
}